<template>
  <div class="activities">
    <div class="create">
      <a-input
        v-model:value="newActivityName"
        size="large"
        maxLength="80"
      ></a-input>
      <a-button size="large" type="primary" @click="createActivity"
        >Create</a-button
      >
    </div>
    <div
      class="activity-card"
      v-for="item in allActivitiesList"
      :key="item.activityId"
    >
      <div
        class="header"
        :style="{
          'flex-direction': !isDesktop && 'column',
          'margin-bottom': !isDesktop && '20px',
          'align-items': !isDesktop && 'start',
        }"
      >
        <div
          class="title"
          :style="{
            'margin-bottom': !isDesktop && '4px',
          }"
        >
          {{ item.name }}
        </div>
        <div class="operation">
          <a-button
            type="primary"
            :style="{
              'margin-left': !isDesktop && '0px',
              padding: !isDesktop && '0 9px',
            }"
            @click="handleShowModal(item.refList, item.activityId)"
          >
            Add a Link
          </a-button>
          <a-button
            v-if="thumbnailMode"
            type="primary"
            :style="{
              padding: !isDesktop && '0 9px',
            }"
            @click="handleShowDetails(item)"
          >
            Link details
          </a-button>
          <a-popconfirm
            title="Are you sure delete this activity?"
            ok-text="Yes"
            cancel-text="No"
            @confirm="handleDelete(item.activityId)"
          >
            <a-button
              :style="{
                padding: !isDesktop && '0 9px',
              }"
              >Delete</a-button
            >
          </a-popconfirm>
        </div>
      </div>
      <div class="content">
        <div v-if="item.refList.length === 0" class="none-content">
          No links here, you can
          <a-button type="link" @click="handleViewAllLinks">
            view all links
          </a-button>
        </div>
        <a-descriptions
          style="margin-top:20px;"
          v-else-if="thumbnailMode"
          layout="horizontal"
          :column="!isDesktop ? 2 : 5"
        >
          <a-descriptions-item
            v-for="ele in tableColumns"
            :key="ele.dataIndex"
            :label="ele.title"
            :style="{
              'text-align': !isDesktop && 'left',
              'padding-bottom': !isDesktop && '10px',
            }"
          >
            <div class="thumbnail-mode-number">
              {{ totalCalc(item.refList, ele.dataIndex) }}
            </div>
          </a-descriptions-item>
        </a-descriptions>
        <ActivitiesTable v-else :tableData="item.refList"></ActivitiesTable>
      </div>
    </div>
    <LinkDetailModal ref="linkDetail"></LinkDetailModal>
    <a-modal
      title="Direct Links"
      :visible="modalVisible"
      @ok="handleAddKeyword"
      @cancel="handleCloseModal"
      okText="Confirm"
    >
      <a-select
        mode="multiple"
        v-model:value="wordLinkList"
        :showSearch="true"
        :filterOption="filterOption"
        style="width:100%"
      >
        <a-select-option
          v-for="item in keywordsListAfterDeduplication"
          :key="item.id"
          :value="item"
          >{{ item.name }}</a-select-option
        >
      </a-select>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LinkDetailModal from './LinkDetailModal'
import ActivitiesTable from '@/components/ActivitiesTable'
import { fetchDeleteActivity } from '@/api/link'

const tableColumns = [
  {
    dataIndex: 'commission',
    title: 'Commission',
  },
  {
    dataIndex: 'clickNumber',
    title: 'Clicks',
  },
  {
    dataIndex: 'newRegistrations',
    title: 'New Registrations',
  },
  {
    dataIndex: 'despositClients',
    title: 'Deposit Clients',
  },
  {
    dataIndex: 'newRealTraders',
    title: 'New Real Traders',
  },
]

export default {
  name: 'ActivityLinks',
  components: { LinkDetailModal, ActivitiesTable },
  computed: {
    ...mapState('link', ['allActivitiesList']),
    // 缩略模式，数据量 > 5 时生效
    thumbnailMode() {
      if (this.allActivitiesList && this.allActivitiesList.length > 5) {
        return true
      } else {
        return false
      }
    },
    isDesktop() {
      return this.$store.state.app.device === 'desktop'
    },
  },
  data() {
    return {
      modalVisible: false,
      newActivityName: undefined,
      tableColumns,
      // 已去重的关键字列表
      keywordsListAfterDeduplication: [],
      // 需要添加关键字的活动id
      selectedActivity: undefined,
      // 添加的关键字列表
      wordLinkList: [],
    }
  },
  methods: {
    createActivity() {
      if (this.newActivityName) {
        this.$store
          .dispatch('link/CreateActivity', this.newActivityName)
          .then(() => {
            this.newActivityName = undefined
            this.$message.success('Success')
            this.$store.dispatch('link/GetAllActivities')
          })
      } else {
        this.$message.warning('Campaign Name is required')
      }
    },
    handleViewAllLinks() {
      this.$emit('update:active', 'keywords')
    },
    // 求和
    totalCalc(arr, label) {
      let result = 0
      arr.forEach((item) => {
        result += item[label]
      })
      return result
    },
    handleShowDetails(data) {
      this.$refs.linkDetail.showModal(data)
    },
    handleDelete(activityId) {
      fetchDeleteActivity({ activityId }).then(() => {
        this.$message.success('Success')
        this.$store.dispatch('link/GetAllActivities')
      })
    },
    // 选中的活动改变时，修改对应的关键字列表（去重）
    handleShowModal(existList, selectedActivity) {
      this.selectedActivity = selectedActivity
      this.keywordsListAfterDeduplication = []
      this.$store
        .dispatch('link/GetKeywordsListByActivityId', {
          activityId: selectedActivity,
        })
        .then((res) => {
          this.keywordsListAfterDeduplication = res
        })
      this.modalVisible = true
    },
    handleAddKeyword() {
      let linkIdList = []
      if (this.wordLinkList.length) {
        linkIdList = this.wordLinkList.map((item) => {
          return {
            id: item.id,
            linkConfigurationType: item.linkConfigurationType,
          }
        })
        this.$store
          .dispatch('link/AddKeywordToActivity', {
            linkIdList,
            activityId: this.selectedActivity,
          })
          .then(() => {
            this.handleCloseModal()
            this.$message.success('Success')
            this.$store.dispatch('link/GetAllActivities')
          })
      } else {
        this.$message.warning('Please select keywords')
      }
    },
    filterOption(input, option) {
      return option.value.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleCloseModal() {
      this.modalVisible = false
      this.wordLinkList = []
    },
  },
}
</script>

<style lang="scss" scoped>
.activities {
  border-radius: 4px;
  border: 1px solid #eceef0;

  .create {
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    padding: 20px;
  }

  .activity-card {
    width: 100%;
    background: #ffffff;
    border-radius: 4px;
    padding: 20px;
    margin-top: 20px;

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        color: #2a6af3;
        font-size: 18px;
        font-weight: 500;
        user-select: auto;
        max-width: 700px;
        word-break: break-all;
        text-align: left;
      }

      .operation {
        .ant-btn {
          margin-left: 10px;
        }
      }
    }

    .content {
      width: 100%;

      .none-content {
        font-size: 18px;
        text-align: center;
        margin: 20px auto;
      }

      .thumbnail-mode-number {
        font-size: 14px;
        font-weight: bold;
        color: #2486df;
        line-height: 20px;
      }
    }
  }
}
@media screen and (min-width: 300px) and (max-width: 374px) {
  .activities .create .ant-input {
    padding: 6.5px 0px;
  }
  .activities .create .ant-btn {
    padding: 0 6px;
  }
  .activities .activity-card {
    padding: 12px 6px;
  }
  .activities .activity-card .header .operation .ant-btn {
    font-size: 12px;
    margin-left: 15px;
  }
}
</style>
